import { Page, Navbar, NavLeft, Link, NavTitle } from 'framework7-react';
import '@styles/subscription.css';
import LeadingIcon from '@assets/icons/Leading.svg?react';

function SubscriptionPage() {
  return (
    <Page name="subscription" className="subscription-page">
      <Navbar className="no-outline">
        <NavLeft>
          <Link back className="icon-only" aria-label="Back">
            <LeadingIcon />
          </Link>
        </NavLeft>
        <NavTitle>About subscription</NavTitle>
      </Navbar>
      <div className="subscription-page-content">
        <h2 className="subscription-subtitle">Your current subscription</h2>

        <div className="subscription-card">
          <div className="subscription-price">
            $29.99 <span className="subscription-period">/ Month</span>
          </div>
        </div>

        

        <div className="subscription-contact">
          To update, change or cancel contact us <br />
          <a
            href="mailto:dealsaver@legalclosing.ca"
            className="subscription-email"
            onClick={() => {
              window.location.href = 'mailto:dealsaver@legalclosing.ca';
            }}
          >
            dealsaver@legalclosing.ca
          </a>
        </div>
      </div>
    </Page>
  );
}

export default SubscriptionPage;
